export default {
  PERSONAL: 'PERSONAL',
  ORGANIZATION: 'ORGANIZATION',
};
